<template>
    <div class="ccpay-delivery-detail">
        <div class="ccpay-order-header">
            <span @click="back">退後</span>
            <span>交割詳情</span>
            <span></span>
        </div>
        <div class="ccpay-order-connect">
            <ul style="padding: 1rem;" v-show="data">
                <li>
                    <p>
                        <span>
                            <b>交割编号 </b>
                        </span>
                        <span> ：{{ data.order_no }}</span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.order_no" @click="copy">复制</span>
                    </p>
                </li>
                
                <li>
                    <p>
                        <span>
                            <b>訂單時間</b> ：{{ data.created_time }}
                        </span>
                    </p>
                </li>

                <li class="bg-f-w">
                    <p>
                        <span>
                            <b>交割状态</b> ：<a :style="{ 'color': getStatusColor() }">{{ getStatusText() }}</a>
                        </span>
                    </p>
                </li>

                <li class="bg-f-w">
                    <p>
                        <span>
                            <b>付款用户姓名</b> ：<a :style="{ 'color': data.side == 'BUY' ? '#54BCA5' : '#CA595B' }">{{ data.name }}</a>
                        </span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.name" @click="copy">复制</span>
                    </p>
                </li>

                <li class="bg-f-w">
                    <p>
                        <span class="detail-spo" style="margin-bottom:0rem">
                            <span>
                                <b>转账金额 </b>：<a :style="{ 'color': data.side == 'BUY' ? '#54BCA5' : '#CA595B' }">{{
                                    data.legal_amount.toString().match(/^\d+(?:\.\d{0,4})?/)[0] }} 元
                                    <!--{{data.legal_currency}} --></a>
                                &nbsp;&nbsp;<span class="fl-r tag-read"
                                    :data-clipboard-text="data.legal_amount.toString().match(/^\d+(?:\.\d{0,4})?/)[0]"
                                    @click="copy">复制</span>
                            </span>
                            <span style="float:right"> <b>类型 </b>：<a
                                    :style="{ 'color': data.side == 'BUY' ? '#54BCA5' : '#CA595B' }">{{ data.side == 'BUY' ?
                                        '买单' : '卖单' }}
                                </a></span>
                        </span>
                    </p>
                </li>

                <li class="bg-f-w">
                    <p>
                        <span>
                            <b>交易员姓名</b> ：{{ getTraderName() }}
                        </span>
                        <span class="fl-r tag-read" :data-clipboard-text="getTraderName()" @click="copy">复制</span>
                    </p>
                </li>

                <li v-show="data.bank_name">
                    <p>
                        <span><b>銀行名稱 </b>：{{ data.bank_name }}</span>
                    </p>
                </li>
                
                <li v-show="data.bank_branch_name">
                    <p>
                        <span class="detail-spo"><b>銀行地址 </b></span>
                        <span>{{ data.bank_branch_name }}</span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.bank_branch_name" @click="copy">复制</span>
                    </p>
                </li>
                
                <li v-show="data.bank_account_no">
                    <p>
                        <span class="detail-spo"><b>銀行卡号 </b></span>
                        <span>{{ data.bank_account_no }}</span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.bank_account_no" @click="copy">复制</span>
                    </p>
                </li>

                <!-- 支付宝信息 -->
                <li v-show="data.alipay_account_name">
                    <p>
                        <span>
                            <b>二维码姓名</b>：{{ data.alipay_account_name }}
                        </span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.alipay_account_name" @click="copy">复制</span>
                    </p>
                </li>
                
                <li class="bg-f-w" v-show="data.alipay_account_no">
                    <p>
                        <span class="detail-spo"><b>二维码帳號 </b></span>
                        <span>{{ data.alipay_account_no }}</span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.alipay_account_no" @click="copy">复制</span>
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { toFixed } from '../../public/index.js'
import Clipboard from 'clipboard';
import moment from "moment"

export default {
    data() {
        return {
            data: null
        }
    },
    mounted() {
        let id = this.$route.query.orderid
        this.$axios(`/v1/traders/order/detail?order_no=${id}`).then(res => {
            if (res.code == 0) {
                this.data = res.data
                console.log('交割详情数据:', res.data)
            } else {
                this.$Toast(res.msg || '获取交割详情失败')
                this.back()
            }
        }).catch(error => {
            console.error('获取交割详情失败:', error)
            this.$Toast('获取交割详情失败')
            this.back()
        })
    },
    methods: {
        toFixed,
        moment,
        back() {
            this.$router.go(-1)
        },
        
        // 获取状态文本
        getStatusText() {
            if (!this.data) return ''
            const statusMap = {
                'CREATED': '已创建',
                'PAID': '已付款',
                'COMPLETE': '交割完成',
                'CANCELLED': '已取消',
                'TIMEOUT': '已超时'
            }
            return statusMap[this.data.status] || this.data.status
        },
        
        // 获取状态颜色
        getStatusColor() {
            if (!this.data) return '#333'
            const colorMap = {
                'COMPLETE': '#54BCA5',
                'PAID': '#FF9500',
                'CREATED': '#26a2ff',
                'CANCELLED': '#CA595B',
                'TIMEOUT': '#CA595B'
            }
            return colorMap[this.data.status] || '#333'
        },
        
        // 获取交易员姓名
        getTraderName() {
            // 根据业务逻辑，这里可能需要调整
            // 如果是银行卡支付，显示银行卡姓名
            if (this.data.bank_account_name) {
                return this.data.bank_account_name
            }
            // 如果是支付宝，显示支付宝姓名
            if (this.data.alipay_account_name) {
                return this.data.alipay_account_name
            }
            // 默认显示通道验证
            return '通道验证'
        },
        
        // 复制功能
        copy() {
            var clipboard = new Clipboard('.tag-read')
            clipboard.on('success', e => {
                this.$Toast('复制成功')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.$Toast('该浏览器不支持自动复制')
                clipboard.destroy()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.ccpay-delivery-detail {
    b {
        font-weight: 400;
    }
}

.bg-f-w {
    -webkit-transform: translateZ(0px);
    transform: translateZ(0px);
    font-size: 14px;
}

.ccpay-delivery-detail {
    height: 100%;
    background: white;

    .ccpay-order-header {
        position: fixed;
        top: 0;
        z-index: 999;
        height: 3rem;
        line-height: 3rem;
        width: 100%;
        background: white;
        display: flex;
        justify-content: space-around;
    }

    .ccpay-order-connect {
        padding-top: 3rem;

        ul li {
            border-bottom: 1px solid #eee;
            display: flex;
            font-size: 16px;
            line-height: 1;
            min-height: inherit;
            overflow: hidden;
            padding: 0 10px;
            padding: 1rem;

            p {
                width: 100%;
            }

            .fl-r {
                float: right;
                color: #26a2ff;
            }

            .detail-spo {
                margin-bottom: 1rem;
                min-width: 5.5rem;
                display: inline-block;
                display: flex;
                justify-content: space-between;
            }
        }
    }

    .proof-imgs {
        display: flex;
        flex-wrap: wrap;
        margin-top: 0.5rem;
        
        .proof-thumb {
            width: 4rem;
            height: 4rem;
            object-fit: cover;
            margin-right: 0.5rem;
            margin-bottom: 0.5rem;
            border-radius: 4px;
        }
    }
    
    .img-preview-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 3000;
        display: flex;
        align-items: center;
        justify-content: center;
        
        .preview-full-img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    }
}
</style> 


// WEBPACK FOOTER //
// src/components/order/DeliveryOrderDetail.vue